<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :isShowApplyStateSelect="true"
    applyStateSelectLabel="审核状态"
    :is-show-administrator-select="isAdministrator"
    administrator-select-label="申请人员"
    :is-show-quick-time-tab="true"
    quick-time-tab-label="申请日期"
    :is-show-quick-time-tab-week="false"
    :is-show-quick-time-tab-last-thirty-day="false"
    :is-show-quick-time-tab-month="true"
    :is-show-quick-time-tab-last-month="true"
    :is-show-student-select="true"
    student-select-label="所属学员"
    :is-show-store-select="isAdministrator"
    :is-multiple-store="true"
    :has-private-store="true"
    store-select-label="申请门店"
    :push-list="RouteConfig.cardAddApplyList.push"
    :query-list="queryList"
  >
    <v-column-time value="申请时间"/>
    <v-column-time v-if="currentState.timeLabel" :value="currentState.timeLabel" field="update_time"/>

    <v-column-avatar label="申请者" avatar-key="admin_avatar" nickname-key="admin_nickname"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请者所属门店"
      width="150"
      align="center"
      prop="store_name"
    />

    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="课卡名称" align="center" prop="card_name"/>
    <el-table-column label="课卡原价" align="center">
      <template v-slot="{ row }">
        <span>{{ row.price | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="实际付款" align="center">
      <template v-slot="{ row }">
        <span>{{ row.actual_payment | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="申请原因" align="center" prop="apply_remark"/>
    <el-table-column label="审核状态" align="center">
      <template v-slot="{ row }">
        <span
          v-for="applyState in findApplyState(row.apply_state)"
          :class="`${applyState.tagType}-color`"
          :key="`applyStateValue${applyState.value}`"
        >
          {{ applyState.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="244">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="view"
          :to="RouteConfig.cardAddApplyDetail.to(row.id)"
        />
        <v-list-button
          v-if="!isAdministrator && row.apply_state === applyStates.review.value"
          name="撤销"
          icon="restore"
          @click="handleRevoke(row)"
          :is-loading="isRevokingIds.includes(row.id)"
          :is-last="true"
          message="确定要撤销申请吗？"
        />
        <v-list-button
          v-if="!isAdministrator && (row.apply_state === applyStates.revoked.value || row.apply_state === applyStates.rejected.value)"
          name="修改"
          icon="edit"
          :to="RouteConfig.cardAddApplyEdit.to(row.id)"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-title border-bottom">
              <span>{{ v.add_time | timeToYmdHi }}</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="divider"></div>
            <div class="list-item-detail">
              <span>申请人员</span>
              <v-avatar-nickname
                :value="v.admin_avatar"
                :nickname="v.admin_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>课卡名称</span>
              <span>{{ v.card_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡原价</span>
              <span class="danger-color">{{ v.price | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>实际付款</span>
              <span class="success-color">{{ v.actual_payment | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>申请原因</span>
              <span>{{ v.apply_remark }}</span>
            </div>
            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="applyState in findApplyState(v.apply_state)"
                :class="`${applyState.tagType}-color`"
                :key="`applyStateValue${applyState.value}`"
              >
                {{ applyState.name }}
              </span>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="view"
                :to="RouteConfig.cardAddApplyDetail.to(v.id)"
              />

              <v-list-button
                v-if="v.apply_state === applyStates.review.value && !isAdministrator"
                name="撤销"
                icon="restore"
                @click="handleRevoke(v)"
                :is-loading="isRevokingIds.includes(v.id)"
                :is-last="true"
                message="确定要撤销申请吗？"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/card-add-apply';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.cardAddApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_states: [applyStates.review.value],
      page: 1,
      size: 10,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowDialog: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    applyInfo: {
      id: 0,
      update_state: applyStates.review.value,
      update_remark: '',
      store: {},
      administrator: {},
      student: {},
      old_student: {},
      card_name: '',
      card_type_name: '',
      card_number: '',
      is_generic: 0,
      is_number_limit: 0,
      is_private: 0,
      expire_number: 0,
      expire_days: 0,
      expire_time: 0,
      actual_payment: 0,
      card_payment_mode_name: '',
      payment_remark: '',
      old_card_name: '',
      old_card_type_name: '',
      old_card_number: '',
      old_is_generic: 0,
      old_is_number_limit: 0,
      old_is_private: 0,
      old_expire_number: 0,
      old_expire_days: 0,
      old_expire_time: 0,
      old_actual_payment: 0,
      old_card_payment_mode_name: '',
      old_payment_remark: '',
    },
    applyStates,
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
    currentState() {
      const states = this.queryList.apply_states;
      if (states.length !== 1) return {};
      return findApplyState(states[0])[0] || {};
    }
  },
  methods: {
    findApplyState,
    refresh() {
      RouteConfig.cardAddApplyList.push(this.queryList);
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async handleRevoke({ id, update_time }) {
      this.isRevokingIds.push(id);
      const { isError } = await destroy(id, update_time);
      removeArrayItem(this.isRevokingIds, id);
      if (!isError) this.load();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>
